import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  (theme: any) => ({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '140px',
      maxWidth: '200px',
      width: '100%'
    },
    containerWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1)
    },
    avatar: {
      background: '#fff',
      width: 40,
      height: 40,
      '& .MuiSvgIcon-root': {
        fontSize: 24
      },
      [theme.breakpoints.between('sm', '1304')]: {
        width: 28,
        height: 28,
        '& .MuiSvgIcon-root': {
          fontSize: 16
        }
      }
    },
    headlineWrapper: {
      minWidth: 70,
      [theme.breakpoints.between('sm', 'lg')]: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    headline: {
      color: '#fff',
      display: 'flex',
      fontSize: 12,
      weight: 600,
      maxWidth: 100,
      marginBottom: 0,
      '& > div': {
        maxWidth: '100px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      [theme.breakpoints.between('sm', 'lg')]: {
        maxWidth: 70,
        marginLeft: '4px',
        justifyContent: 'center',
        '& > div': {
          maxWidth: '70px'
        }
      }
    },
    valueWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    },
    value: {
      color: '#fff',
      fontSize: 26,
      weight: 600,
      marginTop: theme.spacing(1),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      [theme.breakpoints.up('md')]: {
        fontSize: 18
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: 26
      }
    }
  })
);
